module.exports = "<p>\n  card-img works!\n</p>\n"